import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import VisitorTable from './VisitorTable';
import VisitorDrawer from './VisitorDrawer';

const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:8000/api';

export default function VisitorPage({ userid }) {
  const [records, setRecords] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);

  useEffect(() => {
    fetchRecords();
  }, []);

  async function fetchRecords() {
    const res = await fetch(`${API_BASE}/visitors`);
    const data = await res.json();
    setRecords((data || []).map(mapFromApi));
  }

  function mapFromApi(a) {
    return {
      id: a.id,
      name: a.name,
      gender: a.gender,
      mobile: a.mobile,
      aadhar: a.aadhar,
      epic_no: a.epic_no,
      vidhansabha: a.vidhansabha_name || '',
      karad: {
        village: a.village || '',
        ganName: a.gan_name || '',
        zpName: a.zp_name || '',
        reference: a.reference || '',
      },
      other: {
        village: a.village || '',
        taluka: a.taluka || '',
        district: a.district || '',
      },
      booth_no: a.booth_no,
      purpose: a.purpose,
      status: a.status,
      remarks: a.remarks,
      v_entry_date: a.v_entry_date || '',
    };
  }

  async function handleDelete(id) {
    try {
      const res = await fetch(`${API_BASE}/visitors/${id}`, {
        method: 'DELETE',
      });
      if (res.ok) {
        fetchRecords();
      } else {
        console.error('Failed to delete record');
        alert('Failed to delete record');
      }
    } catch (error) {
      console.error('Error deleting record:', error);
      alert('Error deleting record');
    }
  }

  return (
    <Box sx={{ p: 1 }}>
      <VisitorTable
        records={records}
        onAddNew={() => {
          setEditingRecord(null);
          setDrawerOpen(true);
        }}
        onEdit={(record) => {
          setEditingRecord(record);
          setDrawerOpen(true);
        }}
        onDelete={handleDelete}
        refresh={fetchRecords}
      />

      <VisitorDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        editingRecord={editingRecord}
        userid={userid}
        onSaved={() => {
          fetchRecords();
          setDrawerOpen(false);
        }}
      />
    </Box>
  );
}
